import { pushEvent } from '../pushEvent';

const eventName = 'interaction.carousel';

type CarouselAction = 'startClick' | 'previousClick' | 'nextClick';

export const pushCarouselEvent = ({
	action,
	slideNumber,
}: {
	action: CarouselAction;
	slideNumber: number;
}) => {
	pushEvent({
		events: {
			category: eventName,
			action,
			label: `slide-${slideNumber}`,
		},
	});
};
